<!-- <ion-header class="ion-no-border ">
  <ion-toolbar>
    <ion-title class="font18 font600 ion-padding-start" color="primary"> {{"shared.city_list.search_city" | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" color="primary" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header> -->

<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-toolbar>
  <ion-searchbar
    #citySearch
    mode="ios"
    placeholder="{{ 'shared.city_list.search_city' | translate }}"
    (keyup.enter)="filterCityList($event)"
    (ionInput)="filterCityListOnEnter($event)"
  >
  </ion-searchbar>
</ion-toolbar>

<ion-content>
  <ion-grid
    *ngIf="noData === 1 && cityList.length === 0; else showAirportList"
    class="ion-text-center v-center"
  >
    <ion-row>
      <ion-col size="12">
        <ion-label class="font14 font500" color="primary">{{
          "shared.city_list.your_requested_city_is_not_available" | translate
        }}</ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #showAirportList>
    <ion-list class="ion-list-transparent-bg-color">
      <ion-item
        lines="inset"
        class="ion-justify-content-start ion-no-padding ion-item-transparent-bg-color"
        *ngFor="let city of cityList"
        (click)="selectCity(city)"
      >
        <ion-label>
          <p class="font14 font500 paragraph-primary-text-color">
            {{ city.city }}
          </p>
          <p class="font14 font400 paragraph-secondary-text-color">
            {{ city.state }} , {{ city.country }}
          </p>
        </ion-label>
      </ion-item>
    </ion-list>

    <!-- <div *ngIf="cityList.length <= 0 && noData === 0">
      <ion-list>
        <ion-item *ngFor="let item of [0, 1, 2, 3, 4, 5, 6, 7]">
          <ion-label>
            <h3>
              <ion-skeleton-text
                animated
                style="width: 80%; height: 16px"
              ></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text
                animated
                style="width: 50%"
              ></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div> -->
  </ng-template>
</ion-content>
